import React, { useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/student-report/StudentReportAction";
import {
  ExportButton, 
  copy,
  exportToExcel,
  exportToPDF,
  getAuthorities,
  print,
  redirectToPages
} from "../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { StudentReportFilter } from "./student-report-filter/StudentReportFilter";
import { StudentReportTable } from "./student-report-table/StudentReportTable";
import { useStudentReportUIContext } from "./StudentReportUIContext";

export function StudentReportCard() {
  // Student Report UI Context
  const studentReportUIContext = useStudentReportUIContext();
  const studentReportUIProps = useMemo(() => {
    return {
      queryParams: studentReportUIContext.queryParams,
      columns: studentReportUIContext.columns
    };
  }, [studentReportUIContext]);
    
  // Getting curret state of Student Report from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.studentReport }),
    shallowEqual
  );
  const { actionsLoading, isSuccess, type, authorities } = currentState;
  
  // Authority Parameters
  const { isExportationAuthorized } = getAuthorities(authorities);

  // Student Redux state
  const dispatch = useDispatch();

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  // ...
  const exportedColumns = studentReportUIProps.columns.filter(column => !column.hidden);

  /** Belli Bir Öğrenci Raporunu Excele Aktarır */
  const exportStudentReportToExcel = () => {
    dispatch(actions.getAllRegistrationCancellationReport(studentReportUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const widths = exportedColumns.map(column => column.width);
      const columns = exportedColumns.map(column => column.text);
      const fields = exportedColumns.map(column => column.dataField);

      entities.forEach(entity => {
        const row = [];

        fields.forEach(field => {
          const propArr = field.split('.');
          if (propArr.length === 1) row.push(entity[propArr[0]]);
          else if (propArr.length === 2) row.push(entity[propArr[0]][propArr[1]]);
        });
        
        rows.push(row);
      });
      
      const filename = "Öğrenci Raporu";
      exportToExcel({ columns, rows, widths, filename });
    });
  }

  /** Belli Bir Öğrenci Raporunu PDF e Aktarır */
  const exportStudentReportToPDF = () => {
    dispatch(actions.getAllRegistrationCancellationReport(studentReportUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const views = [];

      exportedColumns.forEach(column => {
        const propArr = column.dataField.split('.');
        const view = {
          header: column.text,
          rows: entities.map(entity => {
            if (propArr.length === 1) return entity[propArr[0]];
            else if (propArr.length === 2) return entity[propArr[0]][propArr[1]];
          })
        };
        views.push(view);
      });
  
      const filename = "Öğrenci Raporu";
      exportToPDF(views, filename);
    });
  }

  /** Belli Bir Öğrenci Raporunu Yazdırma Penceresini Açar */
  const printStudentReport = () => {
    dispatch(actions.getAllRegistrationCancellationReport(studentReportUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const data = [];    
      const header = "Öğrenci Raporu";
      const properties = exportedColumns.map(column => column.text);
  
      entities.forEach(entity => {
        const row = {};

        exportedColumns.forEach(column => {
          const propArr = column.dataField.split('.');
          if (propArr.length === 1) row[column.text] = entity[propArr[0]] ?? "";
          else if (propArr.length === 2) row[column.text] = entity[propArr[0]][propArr[1]] ?? "";
        });

        data.push(row);
      });
  
      print({ data, properties, header });
    });    
  }

  /** Belli Bir Öğrenci Raporunu Panoya Kopyalar */
  const copyStudentReport = () => {
    dispatch(actions.getAllRegistrationCancellationReport(studentReportUIProps.queryParams)).then(entities => {
      if (entities.isSuccess === false) return;
      const rows = [];
      const columns = exportedColumns.map(column => column.text);
      const fields = exportedColumns.map(column => column.dataField);
      const header = "Öğrenci Raporu";
      
      entities.forEach(entity => {
        const row = [];

        fields.forEach(field => {
          const propArr = field.split('.');
          if (propArr.length === 1) row.push(entity[propArr[0]] ?? "");
          else if (propArr.length === 2) row.push(entity[propArr[0]][propArr[1]] ?? "");
        });

        rows.push(row);
      });

      copy({ header, columns, rows });
    });
  }
  
  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title="Öğrenci Raporu">
        {
          isExportationAuthorized &&
          <CardHeaderToolbar>            
            <ExportButton
              exportToExcel={exportStudentReportToExcel}
              exportToPDF={exportStudentReportToPDF}
              print={printStudentReport}
              copy={copyStudentReport}
            />
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <StudentReportFilter />
        <StudentReportTable />
      </CardBody>
    </Card>
  );
}